var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.785,
    cy: 11,
    r: 10,
    stroke: "#838F8D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.139 5.62v7.874h5.973",
    stroke: "#838F8D",
    strokeWidth: 2
  })));
};

export { SvgTime as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTEuNzg1MiIgY3k9IjExIiByPSIxMCIgc3Ryb2tlPSIjODM4RjhEIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTExLjEzODcgNS42MjAxMlYxMy40OTQzSDE3LjExMjQiIHN0cm9rZT0iIzgzOEY4RCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";